import { render, staticRenderFns } from "./BarcodeOrderBox24.vue?vue&type=template&id=f45070d2&scoped=true&"
import script from "./BarcodeOrderBox24.vue?vue&type=script&lang=js&"
export * from "./BarcodeOrderBox24.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f45070d2",
  null
  
)

export default component.exports